export default __webpack_public_path__ + "static/media/Screenshot 2022-11-02 at 19.12.04.5c42cbcf.png";